import type { HTMLAttributes } from 'react'
import { PRODUCT_NAME } from '@constants'
import * as S from './styled'

export function Logo(props: HTMLAttributes<HTMLDivElement>) {
  return <S.BrandMark {...props}>{PRODUCT_NAME}</S.BrandMark>
}
